import React from "react";

export type PrettyPrintJsonProps = { data:unknown }

export function PrettyPrintJson(props:PrettyPrintJsonProps):JSX.Element{
    return (
        <pre>{JSON.stringify(props.data, null, 2)}</pre>
    );
}